import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box } from '@mui/material';

import { PRIMARY_PURPLE } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';

const badgeSize = ({ card, compact }) => {
  if (card) {
    return {
      height: 'auto',
      padding: '2px 4px',
      borderRadius: '100px',
      fontSize: '9px',
      lineHeight: '12px',
      letterSpacing: 0,
    };
  }
  if (compact) {
    return {
      height: '13px',
      padding: '0 6px',
      borderRadius: '6.5px',
      fontSize: '8px',
      lineHeight: 1,
      letterSpacing: '0.02em',
    };
  }
  return {
    height: '20px',
    padding: '0 8px',
    borderRadius: '10px',
    fontSize: '11px',
    lineHeight: 1,
    letterSpacing: '0.02em',
  };
};

const FirstTimeShiftBadge = ({ compact = false, card = false }) => (
  <Box
    component="span"
    data-testid="first-time-shift-badge"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: PRIMARY_PURPLE[70],
      color: '#FFFFFF',
      fontFamily: PRIMARY_FONT[700],
      whiteSpace: 'nowrap',
      flexShrink: 0,
      ...badgeSize({ card, compact }),
    }}
  >
    {LanguageConverterV2('jobOrder.firstTimeShift')}
  </Box>
);

FirstTimeShiftBadge.propTypes = {
  compact: PropTypes.bool,
  card: PropTypes.bool,
};

export default FirstTimeShiftBadge;
